/**
 * Защита от цикла редиректов между test.pikinlab.ru и auth.pikinlab.ru.
 * Если за 10 секунд было несколько редиректов на auth — считаем цикл и показываем ошибку.
 */

const KEY_TS = 'auth_redirect_timestamp';
const KEY_COUNT = 'auth_redirect_count';
const WINDOW_MS = 10000;
const MAX_REDIRECTS_IN_WINDOW = 2;

function getStorage(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

/**
 * Можно ли выполнить редирект на auth. Если недавно уже было несколько редиректов — возвращает false.
 */
export function canRedirectToAuth(): boolean {
  const storage = getStorage();
  if (!storage) return true;
  const ts = storage.getItem(KEY_TS);
  const count = storage.getItem(KEY_COUNT);
  if (!ts || !count) return true;
  const t = parseInt(ts, 10);
  const n = parseInt(count, 10);
  if (Number.isNaN(t) || Number.isNaN(n)) return true;
  const now = Date.now();
  if (now - t > WINDOW_MS) return true; // окно истекло
  return n < MAX_REDIRECTS_IN_WINDOW;
}

/**
 * Отметить, что редирект на auth выполняется. Вызывать перед window.location.replace(...).
 */
export function markRedirectToAuth(): void {
  const storage = getStorage();
  if (!storage) return;
  const now = Date.now();
  const ts = storage.getItem(KEY_TS);
  const count = storage.getItem(KEY_COUNT);
  const t = ts ? parseInt(ts, 10) : 0;
  const n = count ? parseInt(count, 10) : 0;
  const inWindow = !Number.isNaN(t) && now - t <= WINDOW_MS;
  storage.setItem(KEY_TS, now.toString());
  storage.setItem(KEY_COUNT, inWindow ? String(n + 1) : '1');
}

/**
 * Сбросить счётчик после успешной авторизации (сессия установлена).
 */
export function clearRedirectGuard(): void {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(KEY_TS);
  storage.removeItem(KEY_COUNT);
}

/**
 * Проверка: считаем ли мы, что идёт цикл (для показа диагностики).
 */
export function isRedirectLoop(): boolean {
  return !canRedirectToAuth();
}
